module.exports = __webpack_public_path__ + "img/p1-info.6636950c.jpg";